import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    status: 'idle',
    renderData: []
};

export const getSupports = createAsyncThunk('/support/get', async () => {

    let res = axios.get('support',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      return data.data.data.Projects


    
})

export const createSupport = createAsyncThunk('/support/create', async (item) => {

    let res = axios.post('support', item,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data, "suppoort post");
      if(data.data.success){
        alert("Loyiha moliyalashtirildi")
      }


    
})
// export const deleteCategory = createAsyncThunk('/categories/delete', async (item) => {

//     let res = axios.delete(`categories/${item.parent._id}`,{
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('token')}`
//         }
//       }).catch((err)=>{
//         console.log(err)
//         // setError(err.response.data.message)
//       })
      
      
//       const data = await res
//       console.log(data);
//       if(data.data.success){
//         alert("Kategoriya o'chirildi")
//       }


    
// })
const support = createSlice({
    name: 'support',
    initialState,
    reducers: {
      sortSupport(state, {payload}) {
        if(payload.role == "admin") {
          state.renderData = state.data
        } else {
          state.renderData = state.data.filter(item => item.user_id._id == payload.id)
        }
      }
    },
    extraReducers(builder) {
      builder
      .addCase(getSupports.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getSupports.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getSupports.fulfilled,(state, action) => {
        // state.status = "idle";
        console.log(action.payload, 'payload');
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createSupport.fulfilled, (state, action) => {
        state.status = 'idle'
      })
    //   .addCase(deleteCategory.fulfilled, (state, action) => {
    //     state.status = 'idle'
    //   })
      }
  });
  export const {sortSupport} = support.actions
export const reducer = support.reducer;